import { render, staticRenderFns } from "./domaine-alain-hudelot-noellat.vue?vue&type=template&id=126ffb30&scoped=true"
import script from "./domaine-alain-hudelot-noellat.vue?vue&type=script&lang=js"
export * from "./domaine-alain-hudelot-noellat.vue?vue&type=script&lang=js"
import style0 from "./domaine-alain-hudelot-noellat.vue?vue&type=style&index=0&id=126ffb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ffb30",
  null
  
)

export default component.exports